import { EmployeeModuleTabConfig } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/types';

export const doTabPathAndStringMatch = <TabPath>(
  tabPath: TabPath,
  tabId: string,
) => {
  return `${tabPath}` === tabId;
};

export const findTabByIdString = <TabPath>(
  tabId: string,
  availableTabs: TabPath[],
): TabPath | undefined => {
  return Object.values(availableTabs).find((e) =>
    doTabPathAndStringMatch(e, tabId),
  );
};

export const getTabByIdString = <TabPath>(
  tabId: string,
  availableTabs: TabPath[],
  defaultTab: TabPath,
): TabPath => {
  const result = findTabByIdString(tabId, availableTabs);
  return !!result ? result : defaultTab;
};

export const resolveLegacyModuleTabPath = <TabPath>(
  tab: TabPath | string | undefined,
  tabPaths: TabPath[],
): TabPath | undefined => {
  return typeof tab === 'string'
    ? tabPaths.find((e) => doTabPathAndStringMatch(e, tab))
    : tab;
};

export const getDefaultTabPath = <TabPath>(
  paths: TabPath[],
  defaultTab: TabPath,
): TabPath | undefined => {
  if (paths.includes(defaultTab)) {
    return defaultTab;
  }

  return paths.length > 0 ? paths[0] : undefined;
};

export const getPathsFromTabConfigs = <
  TabPath,
  TabConfigKey,
  TabInstructionKey,
>(
  tabConfigs: EmployeeModuleTabConfig<
    TabPath,
    TabConfigKey,
    TabInstructionKey
  >[],
): TabPath[] => {
  return tabConfigs.map((c) => c.path);
};

export const filterTabConfigsByEnabledConfigKeys = <
  TabPath,
  TabConfigKey,
  TabInstructionKey,
>(
  tabConfigs: EmployeeModuleTabConfig<
    TabPath,
    TabConfigKey,
    TabInstructionKey
  >[],
  enabledConfigKeys: (TabPath | string)[],
): EmployeeModuleTabConfig<TabPath, TabConfigKey, TabInstructionKey>[] => {
  return tabConfigs?.filter(
    (c) =>
      enabledConfigKeys.includes(c.enabledConfigKey as unknown as string) &&
      !!c.path,
  );
};

export const filterTabConfigsByPath = <
  TabPath,
  TabConfigKey,
  TabInstructionKey,
>(
  tabConfigs: EmployeeModuleTabConfig<
    TabPath,
    TabConfigKey,
    TabInstructionKey
  >[],
  paths: (TabPath | string)[],
): EmployeeModuleTabConfig<TabPath, TabConfigKey, TabInstructionKey>[] => {
  return tabConfigs?.filter(
    (c) => paths.includes(c.path as unknown as string) && !!c.path,
  );
};
